import React, { useEffect } from "react";
import { useState } from "react";
import img1 from "../../assets/images/maqueta/img1.jpg";
import img2 from "../../assets/images/maqueta/img2.jpg";
import img3 from "../../assets/images/maqueta/img3.jpg";
import useNews from "../../hooks/useNews";
import { isVideov2 } from "../../helpers/isVideo";

function CarrouselNews() {
  const { news } = useNews();

  const newsGrandCard = news?.filter(
    (noticia) =>
      noticia?.deleted === false &&
      noticia?.visible === true &&
      noticia?.publish === true
  );
  const imgTensoPrins = [img1, img2, img3];

  const [imgAct, setImg] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setLoading(true);
    }, 2000);
  }, []);

  const cantidad = imgTensoPrins.length;

  const nextimg = () => {
    setImg(imgAct === cantidad - 1 ? 0 : imgAct + 1);
  };

  const backimg = () => {
    setImg(imgAct === 0 ? cantidad - 1 : imgAct - 1);
  };

  const SkeletonCarrousel = () => {
    return (
      <div className="skeleton">
        <div className="container-carrousel-img"></div>
      </div>
    );
  };

  return loading ? (
    <div className="container-carrousel-news">
      <div className="container-carrousel-img">
        <div className="container-button-carrousel">
          <button onClick={nextimg} className="btn-L">
            a
          </button>
          <button onClick={backimg} className="btn-R">
            b
          </button>
        </div>
        <div className="contaner-img-active">
          {newsGrandCard.slice(0, 3).map((noticia, index) => {
            const isVideoCover = isVideov2(
              noticia?.imageCover ? noticia?.imageCover[0]?.url : ""
            );

            return (
              <div
                key={noticia?._id}
                className={imgAct === index ? "container-map" : "hidden"}
              >
                {imgAct === index && (
                  <div className="container-img-act">
                    {isVideoCover ? (
                      <video
                        src={
                          noticia?.imageCover ? noticia?.imageCover[0]?.url : ""
                        }
                        autoPlay
                        muted
                        loop
                        style={{
                          width: '100%',
                          height: '100%', 
                          objectFit: 'fill', 
                        }}
                      />
                    ) : (
                      <picture>
                        <source
                          srcSet={
                            noticia?.imageCover
                              ? noticia?.imageCover[0]?.url
                              : ""
                          }
                          alt={
                            noticia?.imageCover
                              ? noticia?.imageCover[0]?.alt
                              : noticia?.title
                          }
                        />
                        <img
                          src={
                            noticia?.imageCover
                              ? noticia?.imageCover[0]?.url
                              : ""
                          }
                          alt={
                            noticia?.imageCover
                              ? noticia?.imageCover[0]?.alt
                              : noticia?.title
                          }
                        />
                      </picture>
                    )}

                    <div className="container-title-carrousel">
                      <h1>{noticia?.title}</h1>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <SkeletonCarrousel />
  );
}

export default CarrouselNews;
